<template>
  <div class="hhxc-avatar">
    <a-dropdown trigger="click">
      <span class="text-[12px]">
        {{ username }}
        <icon-down />
      </span>

      <template #content>
        <a-doption @click="setting">个人设置</a-doption>
        <a-doption @click="logout">退出登录</a-doption>
      </template>
    </a-dropdown>
    <!-- 个人设置对话框 -->
    <a-modal :mask-closable="false" :visible="settingVisible" title-align="start" width="800px" @cancel="settingVisible = false">
      <template #title>个人设置</template>
      <div
        :style="{
          'min-height': '400px',
          'max-height': '600px',
          overflow: 'auto',
        }"
      >
        <a-menu
          :default-selected-keys="['userInfo']"
          :style="{
            'text-align': 'center',
            fontSize: '16px',
            padding: '0px',
          }"
          mode="horizontal"
          @menu-item-click="menuChange"
        >
          <a-menu-item key="userInfo">个人信息</a-menu-item>
          <!--          <a-menu-item key="dataAuthority">数据权限</a-menu-item>-->
          <a-menu-item key="password">修改密码</a-menu-item>
        </a-menu>
        <div class="content flex_c">
          <div v-if="menuKey === 'userInfo'" class="userInfo">
            <div class="flex_sb">
              <div class="flex">
                <p>姓名：</p>
                <p>{{ userInformation.actualName }}</p>
              </div>
              <div class="flex">
                <p>登录账号：</p>
                <p>{{ userInformation.username }}</p>
              </div>
            </div>
            <div class="flex_sb">
              <div class="flex_a">
                <p>所属组织：</p>
                <div v-for="(item, index) in userInformation.allDeptName" :key="index">
                  {{ `${index + 1}、${item}` }}
                </div>
              </div>
              <div class="flex">
                <p>角色：</p>
                <div v-for="(item, index) in userInformation.userRoleList" :key="item.roleId" class="flex_a">
                  {{ index + 1 == userInformation.userRoleList.length ? item.roleName : item.roleName + '、' }}
                </div>
              </div>
            </div>
            <div class="flex_a">
              <p style="min-width: 70px">直属下级：</p>
              <div v-if="userInformation.childUserList && userInformation.childUserList.length > 0" class="flex_wrap">
                <div v-for="(item, index) in userInformation.childUserList" :key="item">
                  {{ index + 1 == userInformation.childUserList.length ? item : item + '、' }}
                </div>
              </div>
              <div v-else>无</div>
            </div>
          </div>
          <div v-if="menuKey === 'dataAuthority'" class="dataAuthority">
            <div>
              <div class="flex_a">
                <a-popover>
                  <icon-question-circle class="mr10" />
                  <template #content>控制如下模块：Listing、FBA货件、库存看板、销量看板、广告看板</template>
                </a-popover>
                <h4>Asin：{{ asinList[userInformation.asinData] || '无' }}</h4>
              </div>
              <div class="flex_wrap">
                <div v-for="item in authoriList.asinDataIds" :key="item.id" class="mr30">
                  {{ item.deptName || item.seller }}
                </div>
              </div>
            </div>
            <div>
              <div class="flex_a">
                <a-popover>
                  <icon-question-circle class="mr10" />
                  <template #content>控制如下模块：库存看板、销量看板、广告看板、项目管理</template>
                </a-popover>
                <h4>产品：{{ productList[userInformation.productData] || '无' }}</h4>
              </div>
              <div class="flex_wrap">
                <div v-for="item in authoriList.productDataIds" :key="item.id" class="mr30">
                  {{ item.deptName || item.seller }}
                </div>
              </div>
            </div>
            <div>
              <div class="flex_a">
                <a-popover>
                  <icon-question-circle class="mr10" />
                  <template #content>控制如下模块：项目管理</template>
                </a-popover>
                <h4>项目：{{ projectList[userInformation.projectData] || '无' }}</h4>
              </div>
            </div>
            <div>
              <div class="flex_a">
                <a-popover>
                  <icon-question-circle class="mr10" />
                  <template #content>控制如下模块：店铺管理</template>
                </a-popover>
                <h4>店铺：{{ sellerList[userInformation.sellerData] || '无' }}</h4>
              </div>
              <div class="flex_wrap">
                <div v-for="item in authoriList.sellerDataIds" :key="item.id" class="mr30">
                  {{ item.deptName || item.seller }}
                </div>
              </div>
            </div>
            <div>
              <div class="flex_a">
                <a-popover>
                  <icon-question-circle class="mr10" />
                  <template #content>控制如下模块：销售计划-编制计划、计划单、广告计划单</template>
                </a-popover>
                <h4>计划：{{ planList[userInformation.planData] || '无' }}</h4>
              </div>
            </div>
          </div>
          <div v-if="menuKey === 'password'" class="password">
            <a-form ref="formRef" :model="passwordFrom" :style="{ width: '600px' }">
              <a-form-item :rules="[{ required: true, message: '密码为空，请输入密码' }]" field="oldPassword" label="原密码">
                <a-input v-model="passwordFrom.oldPassword" placeholder="请输入原密码" />
              </a-form-item>
              <a-form-item :rules="rules" field="newPassword" label="新密码">
                <a-input-password v-model="passwordFrom.newPassword" autocomplete placeholder="请输入新密码" />
                <template #extra>
                  <div>新密码6~12位，包括大小写字母、特殊字符中的至少2种</div>
                </template>
              </a-form-item>
              <a-form-item :rules="rules" field="passwordAgain" label="确认密码">
                <a-input-password v-model="passwordFrom.passwordAgain" autocomplete placeholder="请再次输入新密码" />
              </a-form-item>
            </a-form>
          </div>
        </div>
      </div>
      <template #footer>
        <vxe-button v-if="menuKey === 'password'" status="primary" @click="handleOk">确认修改</vxe-button>
        <vxe-button @click="settingVisible = false">关闭</vxe-button>
      </template>
      <!-- <div class="footer flex_r">
        <vxe-button
          status="primary"
          v-if="menuKey === 'password'"
          @click="handleOk"
        >
          确认修改
        </vxe-button>
        <vxe-button @click="settingVisible = false">关闭</vxe-button>
      </div> -->
    </a-modal>
  </div>
</template>

<script>
  import { apiUserInfo } from '@/api/system/role'
  import { apiMoidfyPassword } from '@/api/user'
  import { Message } from '@arco-design/web-vue'
  import { computed, reactive, toRefs } from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  import { useStore } from 'vuex'

  class AuthoriList {
    constructor() {
      this.asinDataIds = [] //asin集合
      this.productDataIds = [] //产品集合
      this.sellerDataIds = [] //店铺集合
    }
  }

  export default {
    name: 'HhxcAvatar',
    setup() {
      const store = useStore()
      const router = useRouter()
      const route = useRoute()
      // 修改密码表单验证
      const rules = [
        { required: true, message: '密码为空，请输入密码' },
        {
          minLength: 6,
          maxlength: 12,
          message: '新密码6~12位',
        },
        {
          validator: (value, cb) => {
            const pReg = /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{6,12}$/
            if (!pReg.test(value)) {
              return cb('请按要求输入新密码')
            }
            return true
          },
        },
      ]
      const state = reactive({
        menuKey: 'userInfo',
        userInformation: {},
        passwordFrom: {
          oldPassword: '',
          newPassword: '',
          passwordAgain: '',
        },
        formRef: null,
        settingVisible: false,
        asinList: {
          1: '全部Asin',
          2: '组织的全部Asin',
          3: '店铺的全部Asin',
          4: '自己和下属负责的Asin',
          5: '项目产品的Asin',
          6: '无权限',
        },
        productList: {
          1: '全部产品',
          2: '组织的全部产品',
          3: '项目所包含的产品',
          4: '自己和下属直接负责的产品',
          5: '无权限',
        },
        projectList: {
          1: '全部项目',
          2: '自己和下属参与的项目',
          3: '参与的项目',
          4: '无权限',
        },
        sellerList: {
          1: '全部店铺',
          2: '组织的全部店铺',
          3: '分配的店铺',
          4: '无权限',
        },
        planList: {
          1: '全部计划',
          2: '自己和下属参与的计划',
          3: '项目组员参与的计划',
          4: '无权限',
        },
        authoriList: new AuthoriList(),
      })
      const logout = async () => {
        const fullPath = route.fullPath
        await store.dispatch('user/logout')
        await router.push({ path: '/login', query: { redirect: fullPath } })
      }
      // 打开个人设置对话框
      const setting = async () => {
        state.authoriList = new AuthoriList()
        try {
          const id = localStorage.getItem('userId') || ''
          const res = await apiUserInfo(id)
          if (res.code === '200') {
            const result = JSON.parse(JSON.stringify(res.data))
            // 对所属组织做处理
            const deptName1 = result.userDeptList.map(v => v.deptName)
            result.allDeptName = [result.deptName, ...deptName1]
            state.userInformation = result
            state.settingVisible = true
            /*
          此处判断数据权限的数据（type=1为asin，2为产品，3为项目，4为店铺，5为计划）

          userSellerDataList 为增加店铺
          userDeptDataList为增加组织
        */
            const sourceObj = {
              1: 'asin',
              2: 'product',
              3: 'project',
              4: 'seller',
              5: 'plan',
            }
            // userDeptDataList为组织数据
            if (result.userDeptDataList && result.userDeptDataList.length > 0) {
              const list = JSON.parse(JSON.stringify(result.userDeptDataList))
              list.forEach(w => {
                // 把传过来的deptId字段变为id
                w.id = w.deptId
                state.authoriList[sourceObj[w.type] + 'DataIds'].push(w)
              })
            }
            // userSellerDataList 为店铺数据
            if (result.userSellerDataList && result.userSellerDataList.length > 0) {
              const list = JSON.parse(JSON.stringify(result.userSellerDataList))
              list.forEach(w => {
                state.authoriList[sourceObj[w.type] + 'DataIds'].push(w)
              })
            }
          } else {
            Message.error(`获取个人信息失败，请联系管理员`)
          }
        } catch (error) {
          console.log(error)
        }
      }
      // 个人设置确认修改按钮
      const handleOk = async () => {
        const res = await state.formRef.validate()
        // 判断两次密码是否一样
        const pass = state.passwordFrom.newPassword === state.passwordFrom.passwordAgain
        if (!res && !pass) {
          return await state.formRef.setFields({
            passwordAgain: {
              status: 'error',
              message: '输入两次新密码不一样，请重新输入',
            },
          })
        }
        if (!res) {
          const { oldPassword, newPassword } = state.passwordFrom
          const id = localStorage.getItem('userId')
          try {
            const res = await apiMoidfyPassword({
              id,
              oldPassword,
              newPassword,
            })
            if (res.code === '200') {
              Message.success('修改密码成功')
              state.formRef.resetFields()
            } else {
              Message.error('修改密码失败，请联系管理员')
            }
          } catch (error) {
            console.log(error)
            Message.error('修改失败，请联系管理员')
          }
        }
      }
      // 菜单切换
      const menuChange = key => {
        state.menuKey = key
      }
      return {
        username: computed(() => store.getters['user/actualName']),
        rules,
        logout,
        setting,
        handleOk,
        menuChange,
        ...toRefs(state),
      }
    },
  }
</script>
<style lang="less" scoped>
  .hhxc-avatar {
    float: right;
    margin-right: 20px;
    .ant-dropdown-link {
      display: block;
      min-height: 64px;
      cursor: pointer;
    }
  }
  .password {
    margin-top: 50px;
  }
  :deep(.arco-form-item-content-wrapper) {
    width: 80% !important;
  }
  .userInfo {
    min-width: 700px;
    margin-top: 30px;
    font-size: 14px;
    padding: 0 50px;
    box-sizing: border-box;
    text-align: left;
    & .title {
      width: 100px;
      text-align: right;
    }
    .flex {
      flex: 0 0 33%;
      white-space: nowrap; //  不换行
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .dataAuthority {
    width: 700px;
    margin-top: 30px;
    padding: 0 50px;
    box-sizing: border-box;
  }
  :deep(.arco-icon) {
    color: rgb(163, 163, 163);
  }
</style>
